import React from "react";
import { Card, Container } from "react-bootstrap";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import "./Skills.css";
// import Swiper core and required modules
import SwiperCore, { Autoplay, Pagination, Navigation } from "swiper";

// install Swiper modules
SwiperCore.use([Autoplay, Pagination, Navigation]);

const Skills = () => {
    const skills = [
        {
            image: "https://i.ibb.co/SKB6F4C/javascript.png",
        },
        {
            image: "https://i.ibb.co/wdSwvPr/react.png",
        },
        {
            image: "https://i.ibb.co/sKkDq7p/node.png",
        },
        {
            image: "https://i.ibb.co/QKqcKN5/mongodb.png",
        },
        {
            image: "https://i.ibb.co/jLBsvLj/git.png",
        },
        {
            image: "https://i.ibb.co/WVL0QZp/gitbash.png",
        },
        {
            image: "https://i.ibb.co/P1G7Bfz/netlify.png",
        },
        {
            image: "https://i.ibb.co/rkmmqV3/firebase.png",
        },
        {
            image: "https://i.ibb.co/qLGXcFM/heroku.png",
        },
        {
            image: "https://i.ibb.co/479MvwT/figma.png",
        },
        {
            image: "https://i.ibb.co/fYF131j/xd.png",
        },
    ];

    return (
        <div className="skills">
            <Container className="py-5">
                <div className="text-cen">
                    Skills
                </div>
                <Swiper
                    slidesPerView={3}
                    breakpoints={{
                        240: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                        },
                        768: {
                            slidesPerView: 4,
                            spaceBetween: 40,
                        },
                        1024: {
                            slidesPerView: 6,
                            spaceBetween: 50,
                        },
                    }}
                    spaceBetween={20}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    className="mySwiper"
                >
                    {skills.map((user) => (
                        <SwiperSlide>
                            <Card className="p-3 border-0" style={{ cursor: "pointer" }}>
                                <Card.Body>
                                    <Card.Img
                                        className="img-fluid"
                                        variant="top"
                                        src={user.image}
                                        style={{ width: "64px", height: "64px" }}
                                    />
                                </Card.Body>
                            </Card>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Container>
        </div>
    );
};

export default Skills;